import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css'
import App from './App';

 window.onbeforeunload = function () {
   window.scrollTo(0, 0);
 };

ReactDOM.render(<App />, document.getElementById('root'));
